import React from 'react';
import { Link } from 'gatsby';
import { Container } from './Nav.css';

class Nav extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<Container>
				<div id="menuToggle">
					<input type="checkbox" />

					<span />
					<span />
					<span />

					<ul id="menu">
						<li>
							<Link to="/disintegration-historias-de-la-obra-cumbre-de-the-cure/">
								Historias del disintegration
							</Link>
						</li>
						<li>
							<Link to="/david-m-allen-productor-de-las-placas-superventas-de-robert-smith-la-musica-de-the-cure-te-apoya-y-esta-contigo-cuando-te-sientes-miserable-y-deprimido-y-eso-ha-salvado-a-mucha-gente/">
								Entrevista con el productor David M. Allen
							</Link>
						</li>
						<li>
							<Link to="/andy-vella-disenador-de-las-portadas-de-the-cure-asusta-pensar-que-disintegration-tenga-30-anos/">
								Entrevista con el diseñador Andy Vella
							</Link>
						</li>
						<li>
							<Link to="/pictures-of-you-balada-para-las-fotos-perdidas-de-robert-smith/">
								Las fotos perdidas de Robert Smith
							</Link>
						</li>
						<li>
							<Link to="/lol-tolhurst-la-vida-es-happy-sad-no-es-100-feliz-o-triste/">
								Habla Lol Tolhurst
							</Link>
						</li>
					</ul>
				</div>
			</Container>
		);
	}
}

export default Nav;
